import { useEffect, useState } from "react";
import { Typography, Card } from "@mui/material";
import ProjectCard from "./ProjectCard";
import projectData from "../Data/projects.json"
import useIsMobile from "../AppHelpers";

export interface Project {
    name: string,
    shortDescription:string,
    description: string,
    type: string,
    status: string,
    link?: string
    technologies?: string[],
}


const ProjectSection = ()=> {
    const [projectList, setProjectList] = useState<Project[]>([]);
    const [showMore, setShowMore] = useState(false);
    const [numOfItems, setNumOfItems] = useState(1);
    const isMobile = useIsMobile()

    useEffect(()=>{
        setProjectList(projectData)
    },[])

    const handleShowMore = () =>{
        setShowMore(!showMore)
    }

    const getText =() =>{
        return showMore ? 'Less...' :'More...'
    }

    useEffect(()=>{
        if(showMore){
            setNumOfItems(projectList.length)
        } else{
            setNumOfItems(1)
        }
    
    },[showMore, projectList])

    const getAllowedWidth =()=>{
        return isMobile ? '100vw':'50vw'
    }

    return (
      <Card id='projects' className="ProjectSection ma-2" sx={{backgroundColor:'#420A02', color: '#fff', width:{getAllowedWidth}, margin:'2rem', padding:'2rem'}}>
        <Typography variant="h3" className='mb-0'  align={'left'} sx={{color: '#fff'}}>Projects</Typography>
          {projectList.map((project, i )=> numOfItems >= i && 
             <ProjectCard project={project}></ProjectCard>
        )}
        <Typography variant="h5" className='mt-2'  align={'right'} sx={{color: '#fff', marginTop:'1rem','&:hover':{
              cursor:'pointer'
            }}} onClick={handleShowMore}>{getText()}</Typography> 
      </Card>
    );
  }
  
  export default ProjectSection;